import React from 'react'

class Selection extends React.Component {
  render() {
    return (
      <div className="card card-single select-how-many-people">
        <div className="card-header">
          How many of you are applying for the loan?
        </div>
        <div className="card-body">
          <div className="row btn-group-toggle justify-content-around" data-toggle="buttons">
            <label className="col btn one" onClick={ () => this.props.onChange('primary')} >
              <input id="option1" autoComplete="off" name="options" type="radio" />
              <div id="primary" className="one-person"/>
              One
            </label>
            <label className="col btn two" onClick={ () => this.props.onChange('secondary')} >
              <input id="option2" autoComplete="off" name="options" type="radio" />
              <div id="secondary" className="two-people" />
              Two
            </label>
          </div>
        </div>
      </div>
    )
  }
}

export default Selection;
